
































































import Vue from 'vue'
import Component from 'vue-class-component'
import ContentItemForm from './ContentItemForm.vue'
import List from './List.vue'
import { Prop, Watch } from 'vue-property-decorator'
import { IContentItem, IItemMoveEvent, IModuleManageData } from '../types'

@Component({
  components: {
    ContentItemForm,
    List
  }
})
export default class ManageContentForm extends Vue {
  @Prop()
  initialData!: IModuleManageData

  data: IModuleManageData = {}

  mounted() {
    this.data = this.initialData
  }

  @Watch('initialData')
  initialDataChanged(value: IModuleManageData, oldValue: IModuleManageData) {
    this.data = value
  }

  addContent() {
    // @ts-ignore
    this.data.content.push({ itemOrder: this.data.content.length + 1 })
  }

  moveItem(event: IItemMoveEvent) {
    // @ts-ignore
    const index = this.data.content.findIndex(i => i === event.item)
    switch (event.direction) {
      case 'up':
        if (index === 0) {
          return
        }

        this.data.content = this.data.content || []

        // @ts-ignore
        let prevItem = this.data.content[index - 1]

        this.data.content[index - 1] = event.item
        this.data.content[index] = prevItem
        break
      case 'down':
        // @ts-ignore
        if (index === this.data.content.length - 1) {
          return
        }

        // @ts-ignore
        let nextItem = this.data.content[index + 1]

        // @ts-ignore
        this.data.content[index + 1] = event.item
        // @ts-ignore
        this.data.content[index] = nextItem
        break
    }

    this.updateOrder()
  }

  removeItem(index: number) {
    (this.data.content || []).splice(index, 1)
    this.updateOrder()
  }

  async submit() {
    if (!(this.$refs.form as any).validate()) {
      this.$store.dispatch('showError', 'Invalid data, check your input for clarification')
      return
    }
    this.data.content = (this.data.content || []).filter(i => i.itemType)
    this.$emit('submit', this.data)
  }

  cancel() {
    this.$router.go(-1)
  }

  updateOrder() {
    (this.data.content || []).forEach((item, index) => {
      item.itemOrder = index + 1
    })
    this.$forceUpdate()
  }
}
